import * as React from "react";
const SvgFiRrCompliance = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-compliance_svg__a)">
      <path
        fill="#062147"
        d="M15 6c-1.93 0-3.5 1.57-3.5 3.5S13.07 13 15 13s3.5-1.57 3.5-3.5S16.93 6 15 6m0 5c-.827 0-1.5-.673-1.5-1.5S14.173 8 15 8s1.5.673 1.5 1.5S15.827 11 15 11m-2.001 3H8.816l.58-3.265c.057-.334.029-.519.007-.599C9.215 9.446 8.653 9 7.971 9q-.32 0-.64.132c-.254.105-.503.367-.682.719L4.456 14H3a3 3 0 0 0-3 3v4a3 3 0 0 0 3 3h8.379a4 4 0 0 0 3.922-3.216l.639-3.196A3 3 0 0 0 12.999 14M2 21v-4c0-.551.449-1 1-1h1v6H3c-.551 0-1-.449-1-1m11.98-3.804-.639 3.196A2.005 2.005 0 0 1 11.38 22H6.001v-6H13c.412 0 .661.229.773.366a.99.99 0 0 1 .207.83m9.048-2.616a1 1 0 0 1-1.379.311l-.901-.57a7.6 7.6 0 0 1-1.131 1.091.996.996 0 0 1-1.403-.171 1 1 0 0 1 .171-1.403c.492-.385 2.116-1.837 2.116-4.337 0-3.032-2.468-5.5-5.5-5.5a5.48 5.48 0 0 0-4.636 2.539 1 1 0 0 1-1.381.304L7.299 5.767a1 1 0 0 1 1.077-1.686l.898.574A7.46 7.46 0 0 1 14 2.067V1.001a1 1 0 1 1 2 0v1.067a7.5 7.5 0 0 1 4.677 2.537l.896-.585a1.001 1.001 0 0 1 1.094 1.676l-.895.584c.466.976.728 2.069.728 3.221a7.5 7.5 0 0 1-.681 3.133l.898.568a1 1 0 0 1 .311 1.379z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-compliance_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCompliance;
